import React from 'react'
import styled from 'styled-components';
import { device } from "../device";

const Button = styled.button`
    background-color: transparent;
    border: none;
    left: 50%;
    padding: 0;;
    position: absolute;
    top: 44px;
    transform: translateX(-50%);
    width: 32px;
    z-index: 10002;
    @media ${device.sm} {
        width: 46px;
    }
    @media ${device.lg} {
        display: none;
    }
    svg {
        width: 100%;
    }
`;

const ChevronButton = ({onClick}) => {
    const chevron = <svg width="48" height="16" viewBox="0 0 48 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 2L24 13.5L47 2" stroke="white" strokeWidth="3"/>
    </svg>

    return (
        <Button className="fadeInBtn" onClick={onClick}>
            {chevron}
        </Button>
    )
    
}

export default ChevronButton;